"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureAnnotationsOverlay = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _ccxIngest = require("@ccx-public/ccx-ingest");

var _AppContext = require("../context/AppContext");

var _CallbackContext = _interopRequireDefault(require("../context/CallbackContext"));

var _selectors = require("../selectors");

var _annotations = require("../selectors/annotations");

var _Annotations = _interopRequireDefault(require("../containers/Annotations"));

var _AnnotationsMask = _interopRequireDefault(require("./AnnotationsMask"));

var AnnotationActions = _interopRequireWildcard(require("../actions/annotation"));

var ContextActions = _interopRequireWildcard(require("../actions/context"));

var _comments = require("../actions/comments");

var _constants = require("../constants");

var _reducers = require("../reducers");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * AnnotationsOverlay component
 * @reactProps {number} [scaleFactorX = 1] - value used to scale in the X direction equal to the scale of the asset rendition
 * @reactProps {number} [scaleFactorY = 1] - value used to scale in the Y direction equal to the scale of the asset rendition
 * @reactProps {string} [sectionId] - value used to define a unique section of an asset
 * @reactProps {bool} [showHighlight] - boolean to indicate if the annotation should be highlighted when user is hovering to place an annotation
 * @reactProps {object} [style] - object used to apply inline styles to the component
 */
var AnnotationsOverlay = /*#__PURE__*/function (_React$Component) {
  _inherits(AnnotationsOverlay, _React$Component);

  var _super = _createSuper(AnnotationsOverlay);

  /**
   * Constructor for AnnotationsOverlay
   * @param {object} props - props sent to the component
   * @returns {undefined}
   */
  function AnnotationsOverlay(props) {
    var _this;

    _classCallCheck(this, AnnotationsOverlay);

    _this = _super.call(this, props);
    _this.state = {
      hadError: false
    };
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_assertThisInitialized(_this));
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_assertThisInitialized(_this));
    _this.handlePinDrop = _this.handlePinDrop.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Lifecycle method for updating state for an error boundary
   * @returns {undefined}
   */


  _createClass(AnnotationsOverlay, [{
    key: "componentDidCatch",

    /**
     * Lifecycle method for catching an error
     * @param {object} error - error captured by error handler
     * @returns {undefined}
     */
    value: function componentDidCatch(error) {
      var _this$props = this.props,
          ccxIngest = _this$props.ccxIngest,
          environment = _this$props.environment;
      ccxIngest.fireEvent({
        event: {
          subcategory: 'general-error',
          subtype: 'error',
          type: 'render',
          error_type: error.message && error.message.replace(/\s/g, '-'),
          error_desc: 'annotations-js-error',
          build: environment
        }
      });
    }
    /**
     * Handle hovering over the component
     * @returns {undefined}
     */

  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState({
        hovered: true
      });
    }
    /**
     * Handle hovering off the component
     * @returns {undefined}
     */

  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        hovered: false
      });
    }
    /**
     * Handles updating pin annotation data.
     * @param {Object} assetId - id for the current asset
     * @param {Object} comment - comment associated with the annotation
     * @param {Object} coordinates - new coordinates of the annotation
     * @param {Object} nodeId - node ID for the annotation
     * @return {undefined}
     */

  }, {
    key: "handlePinDrop",
    value: function handlePinDrop(assetId, comment, coordinates, nodeId) {
      // eslint-disable-next-line no-shadow
      var _this$props2 = this.props,
          ccxIngest = _this$props2.ccxIngest,
          imsData = _this$props2.imsData,
          resetGuestUserSession = _this$props2.resetGuestUserSession,
          updateAnnotation = _this$props2.updateAnnotation;
      var onLogin = this.context.onLogin;
      updateAnnotation(assetId, comment, coordinates, nodeId).then(function () {
        return ccxIngest.fireEvent({
          event: {
            subcategory: 'pin-comment',
            type: 'click',
            subtype: 'drag-drop'
          }
        });
      }).catch(function (error) {
        ccxIngest.fireEvent({
          event: {
            subcategory: 'edit-comment',
            subtype: 'error',
            type: 'render',
            error_code: error.status,
            error_type: error.message,
            error_desc: 'comment-failed-to-edit'
          }
        });

        if (imsData.token.includes('AnonBearer') && error.status === 401) {
          resetGuestUserSession();
          onLogin(false);
        }
      });
    }
    /**
     * Lifecycle method for rendering
     * @returns {ReactElement} markup
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          maskStyle = _this$props3.maskStyle,
          maskTextOverride = _this$props3.maskTextOverride,
          useMask = _this$props3.useMask,
          nodeId = _this$props3.nodeId,
          assetData = _this$props3.assetData;
      var _this$state = this.state,
          hadError = _this$state.hadError,
          hovered = _this$state.hovered;
      var useNodeIndex = assetData.useNodeIndex;
      var newNodeId = nodeId;

      if (useNodeIndex) {
        newNodeId = !isNaN(Number(nodeId)) ? Number(nodeId) : nodeId;
      }

      if (hadError) {
        return null;
      }

      var annotations = /*#__PURE__*/_react.default.createElement(_Annotations.default, _extends({}, this.props, {
        nodeId: newNodeId,
        onPinDrop: this.handlePinDrop
      }));

      if (!useMask) {
        return annotations;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        style: {
          pointerEvents: 'none',
          position: 'absolute',
          touchAction: 'pinch-zoom',
          height: '100%',
          width: '100%',
          top: 0
        }
      }, annotations, /*#__PURE__*/_react.default.createElement(_AnnotationsMask.default, {
        hovered: hovered,
        maskTextOverride: maskTextOverride,
        style: maskStyle
      }));
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hadError: true
      };
    }
  }]);

  return AnnotationsOverlay;
}(_react.default.Component);

exports.PureAnnotationsOverlay = AnnotationsOverlay;

_defineProperty(AnnotationsOverlay, "contextType", _CallbackContext.default);

AnnotationsOverlay.defaultProps = {
  comments: [],
  imsData: {},
  updateAnnotation: function updateAnnotation() {}
};
AnnotationsOverlay.propTypes = {
  assetData: _propTypes.default.shape({
    id: _propTypes.default.string,
    nodeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    ownerId: _propTypes.default.string,
    region: _propTypes.default.string,
    useNodeIndex: _propTypes.default.bool
  }),
  useMask: _propTypes.default.bool,
  ccxIngest: _propTypes.default.object,
  comments: _propTypes.default.array,
  imsData: _propTypes.default.shape({
    id: _propTypes.default.string,
    token: _propTypes.default.string
  }),
  nodeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  setAnnotationMode: _propTypes.default.func,
  style: _propTypes.default.object,
  environment: _propTypes.default.string,
  maskTextOverride: _propTypes.default.string,
  maskStyle: _propTypes.default.object,
  updateAnnotation: _propTypes.default.func,
  resetGuestUserSession: _propTypes.default.func
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    annotationColor: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.annotationColor")),
    annotationLocationCoordinates: (0, _annotations.getAnnotationLocationCoordinates)(state),
    annotationLocationNodeId: (0, _annotations.getAnnotationLocationNodeId)(state),
    annotationsEnabled: ownProps.annotationsEnabled,
    commentProposedForDelete: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.commentProposedForDelete")),
    comments: (0, _selectors.getFilteredComments)(state, ownProps),
    commentsListMinimized: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.commentsListMinimized")),
    drawingNode: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":annotation.drawingNode")),
    focusedInputInfo: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.focusedInputInfo")),
    hasAnnotationLocation: (0, _annotations.getHasAnnotationLocation)(state),
    hoveredAnnotation: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":annotation.hoveredAnnotation")),
    imageCoordinatesInfo: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.imageCoordinatesInfo")),
    isPlacingAnnotation: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.isPlacingAnnotation")),
    mobileCommentsListOffsetTop: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.mobileCommentsListOffsetTop")),
    newAnnotationType: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.newAnnotationType")),
    annotatingItmId: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.annotatingItmId")),
    registeredSectionIds: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.registeredSectionIds")),
    selectedAnnotationId: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":annotation.selectedAnnotationId")),
    showAnnotations: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.showAnnotations")),
    showResolvedComments: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.showResolvedComments")),
    touchPressed: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":annotation.touchPressed")),
    viewingUnmapped: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.viewingUnmapped"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    updateAnnotation: _comments.updateAnnotation,
    registerSectionId: ContextActions.contextRegisterSectionId,
    remapCommentNodes: _comments.remapCommentNodes,
    resetGuestUserSession: ContextActions.contextResetGuestUserSession,
    saveAnnotationLocation: ContextActions.contextSaveAnnotationLocation,
    setAnnotationMode: ContextActions.contextSetAnnotationMode,
    setClickedAnnotation: ContextActions.contextSetClickedAnnotation,
    setHoveredAnnotation: AnnotationActions.annotationSetHoveredAnnotation,
    saveImageCoordinatesInfo: ContextActions.contextSaveImageCoordinatesInfo,
    setDrawingNode: AnnotationActions.annotationSetDrawingNode,
    setCommentsListMinimized: ContextActions.contextSetCommentsListMinimized,
    setTouchPressed: AnnotationActions.annotationSetTouchPressed,
    setSelectedAnnotationId: AnnotationActions.annotationSetSelectedAnnotationId
  }, dispatch);
};

var enhance = (0, _redux.compose)(_AppContext.withAppContext, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, undefined, {
  context: _reducers.reduxContext
}), (0, _ccxIngest.ccxIngest)(_constants.INGEST_PROJECT_VALUE));

var _default = enhance(AnnotationsOverlay);

exports.default = _default;